/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateEodImportLogDto
 */
export interface CreateUpdateEodImportLogDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEodImportLogDto
     */
    companyId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateEodImportLogDto
     */
    documentId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEodImportLogDto
     */
    documentExternalNumber?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof CreateUpdateEodImportLogDto
     */
    documentIssueDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEodImportLogDto
     */
    reason: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEodImportLogDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEodImportLogDto
     */
    creatorId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEodImportLogDto
     */
    ownerId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEodImportLogDto
     */
    purchaseInvoiceId?: string;
}

/**
 * Check if a given object implements the CreateUpdateEodImportLogDto interface.
 */
export function instanceOfCreateUpdateEodImportLogDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyId" in value;
    isInstance = isInstance && "reason" in value;

    return isInstance;
}

export function CreateUpdateEodImportLogDtoFromJSON(json: any): CreateUpdateEodImportLogDto {
    return CreateUpdateEodImportLogDtoFromJSONTyped(json, false);
}

export function CreateUpdateEodImportLogDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateEodImportLogDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyId': json['companyId'],
        'documentId': !exists(json, 'documentId') ? undefined : json['documentId'],
        'documentExternalNumber': !exists(json, 'documentExternalNumber') ? undefined : json['documentExternalNumber'],
        'documentIssueDate': !exists(json, 'documentIssueDate') ? undefined : (json['documentIssueDate'] === null ? null : new Date(json['documentIssueDate'])),
        'reason': json['reason'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'creatorId': !exists(json, 'creatorId') ? undefined : json['creatorId'],
        'ownerId': !exists(json, 'ownerId') ? undefined : json['ownerId'],
        'purchaseInvoiceId': !exists(json, 'purchaseInvoiceId') ? undefined : json['purchaseInvoiceId'],
    };
}

export function CreateUpdateEodImportLogDtoToJSON(value?: CreateUpdateEodImportLogDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'companyId': value.companyId,
        'documentId': value.documentId,
        'documentExternalNumber': value.documentExternalNumber,
        'documentIssueDate': value.documentIssueDate === undefined ? undefined : (value.documentIssueDate === null ? null : value.documentIssueDate.toISOString()),
        'reason': value.reason,
        'description': value.description,
        'creatorId': value.creatorId,
        'ownerId': value.ownerId,
        'purchaseInvoiceId': value.purchaseInvoiceId,
    };
}

